module.exports = __webpack_public_path__ + "static/mission-13fc56b2294f4b9d9a9acdcc305f2697.svg";